import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { TASK_KEYS } from './queryKeys';
import { tasksService } from '../api/tasks.service';
import type { ImportTasksResponse } from '../types';

export function useImportTasks(projectId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation<ImportTasksResponse, Error, FormData>({
    mutationFn: (formData: FormData) => tasksService.importTasks(projectId, formData),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TASK_KEYS.projectRoot(orgId, projectId) });
    },
  });
}
